import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, withCtx as _withCtx, mergeProps as _mergeProps, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { computed, ref } from 'vue'
import { useI18n } from 'vue-i18n'

import { ModelEvent } from '@/app/types/app/event'

import IconButton from '@C/ui/button/IconButton.vue'
import AppInput from '@C/ui/form/AppInput.vue'
import EyeIcon from '@C/ui/icons/EyeIcon.vue'

interface Emits {
  (event: ModelEvent.UpdateModelValue, value: string)
}


export default /*#__PURE__*/_defineComponent({
  __name: 'PasswordInput',
  setup(__props, { emit }) {



const { t } = useI18n()

const isPassVisible = ref(false)

const inputType = computed(() => (isPassVisible.value ? 'text' : 'password'))

function onInput(value: string) {
  emit(ModelEvent.UpdateModelValue, value)
}

function showPassword() {
  isPassVisible.value = !isPassVisible.value
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(AppInput, _mergeProps({
    type: inputType.value,
    autocomplete: "password",
    label: _unref(t)('common.labels.password')
  }, _ctx.$attrs, { "onUpdate:modelValue": onInput }), {
    append: _withCtx(() => [
      _createVNode(IconButton, { onClick: showPassword }, {
        default: _withCtx(() => [
          _createVNode(EyeIcon, { "is-opened": isPassVisible.value }, null, 8, ["is-opened"])
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 16, ["type", "label"]))
}
}

})